import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";
import AlertsList from "./AlertsList";
import { Box, Card, CircularProgress, Divider, Typography } from "@mui/material";
import { fetchRequest, bulkUpdateResponse } from "../../../store/actions/alerts";
import { useLocation } from "react-router-dom";
import { ResponsivePie } from "@nivo/pie";
let intialValue=[
  { text: "New", value: true },
  { text: "Acknowledged", value: true },
  { text: "Resolved", value: true },
  { text: "Auto Resolved", value: false },  
]

const Alerts = () => {
  const locationObj = useLocation();
  const dispatch = useDispatch();
  const {
    deviceId,
    deviceName,
    organization,
    location,
    status,
    level,
    subject,
    shipmentname,
  } = locationObj.state || {
    deviceId: "",
    deviceName:"",
    organization: "",
    locationId: "",
    status: "",
    level: "",
    subject: "",
    shipmentname: "",
  };
  const alarmCounts = useSelector((state) => state.alert.alertCounts);
  const alertStatusCounts = useSelector((state) => state.alert.alertStatusCounts);
  const filters = useSelector((state) => state.alert.filters);
  const isLoading = useSelector((state) => state.alert.isLoading);
  const alertStatusCountsIsLoading = useSelector((state) => state.alert.alertStatusCountsIsLoading);
  const alertCountIsLoading = useSelector((state) => state.alert.alertCountIsLoading);
  const user = useSelector((state) => state.auth.user);
  const isNotificationActive = useSelector(
    (state) => state.alert.notification.isActive
  );

  useEffect(() => {
    if (isNotificationActive) {
      dispatch(
        bulkUpdateResponse({
          isActive: false,
          message: "",
          description: "",
        })
      );
    } else if(deviceId!==null&&deviceId!=="") {
      let order = "desc";
      dispatch(
        fetchRequest({
          ...filters,
          status:intialValue,
          sort: [{ field: "$/metadata/device-name", order }],
          device: deviceId,
        })
      );
    }else{
      dispatch(
        fetchRequest({
          isLoaded: false,
          status:intialValue,
          level: level || "",
          subject: subject || "",
          shipmentname: shipmentname || "",
          device: deviceId ? [deviceId] : [],
          lastUpdated: "",
          organization: organization ? [organization] : [],
          location: location ? [location] : [],
          sort: [
            {
              field: "createdon",
              order: "desc",
            },
          ],
          pagenumber: 0,
          limitnumber: 100,
        })
      );
    }
  }, [
    dispatch,
    deviceId,
    deviceName,
    organization,
    location,
    level,
    status,
    subject,
    shipmentname,
    isNotificationActive,
    user?.accountId
  ]);

  const handleClick = (val) => {
    let data = {
      Critical: val == "critical" ? true : false,
      Warning: val == "warning" ? true : false,
      Notification: val == "notification" ? true : false,
    }
    dispatch(fetchRequest({ ...filters, level: data }));
  };
  const handlePieChartClick = (val) => {
    let data = {
      Critical: val.node.id == "critical" ? true : false,
      Warning: val.node.id == "warning" ? true : false,
      Notification: val.node.id == "notification" ? true : false,
    }
    dispatch(fetchRequest({ ...filters, level: data }));
  };

  const handleStatusFilterChange = (status) => {
    let statusValue = {
      "New": status===""?true:false,
      "Acknowledged":status===""?true:false ,
      "Resolved": status===""?true:false,
      "Auto Resolved": false,
    };

    if (status === "New") statusValue["New"] = true;
    if (status === "Resolved") statusValue["Resolved"] = true;
    if (status === "Auto Resolved") statusValue["Auto Resolved"] = true;
    if (status === "Acknowledged") statusValue["Acknowledged"] = true;
    const filterArr = Object.entries(statusValue);

    if (filterArr.length === 0) {
      return;
    }

    const filterValue = filterArr.map((filter) => ({
      text: filter[0],
      value: filter[1],
    }));

    dispatch(
      fetchRequest({
        ...filters,
        status: filterValue,
      })
    );
  };


  const data = 
     alarmCounts?.total > 0
      ? [
    {
      id: "critical",
      label: "Error",
      value: alarmCounts.critical,
      color: "#FF8027",
    },
    {
      id: "warning",
      label: "Warning",
      value: alarmCounts.warning,
      color: "#FED60E",
    },
    {
      id: "notification",
      label: "Notification",
      value: alarmCounts.notification,
      color: "#0089EC",
    },
  ].filter(item => item?.value > 0)
   : [
        {
          id: "",
          label: "",
          value: 1,
          color: "#D8DADA",
        },
      ];

  const dataStatus  =
    alertStatusCounts?.total > 0
      ? [
    {
      id: "New",
      label: "New",
      value: alertStatusCounts.new,
      color: "#003E6C",
    },
    {
      id: "Resolved",
      label: "Resolved",
      value: alertStatusCounts.resolved,
      color: "#4AABF2",
    },
    {
      id: "Acknowledged",
      label: "Acknowledged",
      value: alertStatusCounts.acknowledged,
      color: "#006FC1",
    },
    {
      id: "Auto Resolved",
      label: "Auto Resolved",
      value: alertStatusCounts.autoresolved,
      color: "#AAD8F9",
    },
  ].filter(item => item?.value > 0) : [
        {
          id: "",
          label: "",
          value: 1,
          color: "#D8DADA",
        },
      ];

  return (
  <Grid2 container spacing={4} sx={{ marginTop: 2 }}>
  {/* Alert Status Card */}
  <Grid2 item xs={12} md={6}>
    <Card
      elevation={3}
      sx={{
        backgroundColor: "#FFFFFF",
        padding: 3,
        borderRadius: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 420, // prevent bounce
      }}
    >
      <Typography variant="h6" className="font-face-vzw-alert" sx={{ marginBottom: 2 }}>
        ALERT STATUS
      </Typography>

      <Box
        sx={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          gap: 15,
          minHeight: 250,
        }}
      >
        {/* Pie Chart */}
        <Box sx={{ width: 213, height: 213 }}>
          <ResponsivePie
            data={dataStatus}
            innerRadius={0.78}
            colors={{ datum: "data.color" }}
            borderWidth={1}
            borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
            enableArcLinkLabels={false}
            enableArcLabels={false}
            arcLabelsTextColor="#000"
            onClick={(node, e) => handleStatusFilterChange(node.id)}
            layers={[
              "arcs",
              "arcLabels",
              "legends",
              (props) => (
                <text
                  x={props.centerX}
                  y={props.centerY - 15}
                  textAnchor="middle"
                  onClick={() => handleStatusFilterChange("")}
                  dominantBaseline="central"
                  style={{
                    fontSize: props.width < 200 ? 20 : 26,
                    fontWeight: "700",
                    fontFamily: "VerizonNHGDS",
                    fill: "#000",
                  }}
                >
                  {alertStatusCounts.total}
                  <tspan
                    x={props.centerX}
                    y={props.centerY + 12}
                    fontSize={props.width < 200 ? 14 : 17}
                    fontWeight="400"
                    fontFamily="VerizonNHGDS"
                    fill="#000"
                  >
                    Total alerts
                  </tspan>
                </text>
              ),
            ]}
            theme={{
              labels: {
                text: {
                  fontSize: 14,
                  fontWeight: "bold",
                },
              },
            }}
          />
        </Box>

        {/* Status List */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {[
            { label: "New", count: alertStatusCounts.new, color: "#003E6C" },
            { label: "Acknowledged", count: alertStatusCounts.acknowledged, color: "#006FC1" },
            { label: "Resolved", count: alertStatusCounts.resolved, color: "#4AABF2" },
            { label: "Auto Resolved", count: alertStatusCounts.autoresolved, color: "#AAD8F9" },
          ].map(({ label, count, color }) => (
            <Box
              key={label}
              onClick={() => count > 0 && handleStatusFilterChange(label)}
              className="alarm-new-container-online"
              sx={{
                pointerEvents: count === 0 ? "none" : "auto",
                cursor: "pointer",
                borderLeft: `6px solid ${color}`,
                p: 0.75,
                backgroundColor: "#fff",
                minWidth: 180,
                minHeight: 60,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Typography className="device-card-title">{label}</Typography>
              <Box
                className="alert-count-val"
                sx={{
                  minHeight: 24,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {!alertStatusCountsIsLoading && !alertCountIsLoading ? (
                  <Typography>{count}</Typography>
                ) : (
                  <CircularProgress size={20} />
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Card>
  </Grid2>

  {/* Alert Severity Card */}
  <Grid2 item xs={12} md={6}>
    <Card
      elevation={3}
      sx={{
        backgroundColor: "#FFFFFF",
        padding: 3,
        borderRadius: 2,
        height: "100%",
        display: "flex",
        flexDirection: "column",
        minHeight: 420,
      }}
    >
      <Typography variant="h6" className="font-face-vzw-alert" sx={{ marginBottom: 2 }}>
        ALERT SEVERITY
      </Typography>

      <Box
        sx={{
          display: "flex",
          flex: 1,
          alignItems: "center",
          justifyContent: "center",
          gap: 15,
          minHeight: 250,
        }}
      >
        {/* Severity Pie Chart */}
        <Box sx={{ width: 213, height: 213 }}>
          <ResponsivePie
            data={data}
            innerRadius={0.78}
            colors={{ datum: "data.color" }}
            borderWidth={1}
            borderColor={{ from: "color", modifiers: [["darker", 0.2]] }}
            enableArcLinkLabels={false}
            enableArcLabels={false}
            arcLabelsTextColor="#000"
            onClick={(node, e) => handlePieChartClick({ node, event: e })}
            layers={[
              "arcs",
              "arcLabels",
              "legends",
              (props) => (
                <text
                  x={props.centerX}
                  y={props.centerY - 15}
                  textAnchor="middle"
                  onClick={() => handleClick("")}
                  dominantBaseline="central"
                  style={{
                    fontSize: props.width < 200 ? 20 : 26,
                    fontWeight: "700",
                    fontFamily: "VerizonNHGDS",
                    fill: "#000",
                  }}
                >
                  {alarmCounts.total}
                  <tspan
                    x={props.centerX}
                    y={props.centerY + 12}
                    fontSize={props.width < 200 ? 14 : 17}
                    fontWeight="400"
                    fontFamily="VerizonNHGDS"
                    fill="#000"
                  >
                    Total alerts
                  </tspan>
                </text>
              ),
            ]}
            theme={{
              labels: {
                text: {
                  fontSize: 14,
                  fontWeight: "bold",
                },
              },
            }}
          />
        </Box>

        {/* Severity List */}
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
          {[
            { label: "Notification", count: alarmCounts.notification, color: "#0089EC" },
            { label: "Critical", count: alarmCounts.critical, color: "#FF8027" },
            { label: "Warning", count: alarmCounts.warning, color: "#FED60E" },
          ].map(({ label, count, color }) => (
            <Box
              key={label}
              onClick={() => count > 0 && handleClick(label.toLowerCase())}
              className="alarm-new-container-online"
              sx={{
                pointerEvents: count === 0 ? "none" : "auto",
                cursor: "pointer",
                borderLeft: `6px solid ${color}`,
                p: 0.75,
                backgroundColor: "#fff",
                minWidth: 180,
                minHeight: 60,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
              }}
            >
              <Typography className="device-card-title">{label}</Typography>
              <Box
                className="alert-count-val"
                sx={{
                  minHeight: 24,
                  display: "flex",
                  alignItems: "center",
                }}
              >
                {!alertStatusCountsIsLoading && !alertCountIsLoading ? (
                  <Typography>{count}</Typography>
                ) : (
                  <CircularProgress size={20} />
                )}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
    </Card>
  </Grid2>

  {/* Optional: Alerts List below both cards */}
  <Grid2 item xs={12} sx={{ mt: -1.5 }}>
    <AlertsList />
  </Grid2>
</Grid2>



  );
};

export default Alerts;